<nz-spin [nzSpinning]="spinner">
  <div class="container imports-container">
    <div class="page-header">
      <div>
        <h2>Imports</h2>
        <p class="page-subtitle">Upload data for payroll, providers, pins, and more, then review recent runs.</p>
      </div>
      <div class="header-actions">
        <button *ngIf="currentUser?.super_admin" nz-button nzType="default" nzDanger [nzLoading]="pendingPayLoad" (click)="deletePending()">
          <span nz-icon nzType="delete" nzTheme="outline"></span>
          Delete Pending Pay
        </button>
      </div>
    </div>

    <div class="imports-panel">
      <div class="panel-header">
        <div class="panel-title">Available Imports</div>
        <button nz-button nzType="default" [nzLoading]="payHierarchyExporting" (click)="exportPayHierarchy()" *ngIf="currentUser?.super_admin">
          <span nz-icon nzType="download" nzTheme="outline"></span>
          Export Pay Hierarchy
        </button>
      </div>
      <div class="imports-grid">
        <ng-container *ngFor="let imp of imports">
          <div *ngIf="imp.permission" class="import-card">
            <div class="import-name">{{ imp.name }}</div>
            <csvbox-button [licenseKey]="imp.key" [user]="user" [onImport]="imported.bind(this)">
              <button nz-button nzType="primary" nzBlock>
                <span nz-icon nzType="upload" nzTheme="outline"></span>
                Start Import
              </button>
            </csvbox-button>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="imports-table">
      <div class="panel-title">Recent Imports</div>
      <nz-table #importTable nzBordered [nzData]="importHistory" [nzLoading]="spinner">
        <thead>
          <tr>
            <th [nzSortFn]="sortByDate" nzSortDirections="['descend', 'ascend']">Date</th>
            <th [nzSortFn]="sortByFilename" nzSortDirections="['ascend', 'descend']">File</th>
            <th>Type</th>
            <th>Status</th>
            <th>Success/Total</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let i of importTable.data">
            <td>{{ i.import_date | date}}</td>
            <td>{{ i.filename }}</td>
            <td>{{ i.import_type }}</td>
            <td>
              <span class="status-tag" [ngClass]="{
                completed: i.status === 'completed',
                processing: i.status === 'processing',
                deleted: i.status === 'deleted records'
              }">
                <span *ngIf="i.status === 'completed'" nz-icon nzType="check-circle" nzTheme="outline"></span>
                <span *ngIf="i.status === 'processing'" nz-icon nzType="loading" nzTheme="outline"></span>
                <span *ngIf="i.status === 'deleted records'" nz-icon nzType="delete" nzTheme="outline"></span>
                {{ i.status | titlecase }}
              </span>
            </td>
            <td>{{i.successful_records}}/{{i.total_records}}</td>
            <td class="table-actions">
              <a *ngIf="i.failed_records_data > 0" (click)="exportFailedRecords(i.id)">
                <span nz-icon nzType="download" nzTheme="outline"></span>
                Failed Records
              </a>
              <a *ngIf="i.deletable" class="danger" (click)="showDeleteConfirm(i)">
                <span nz-icon nzType="delete" nzTheme="outline"></span>
                Delete Records
              </a>
              <span *ngIf="!(i.failed_records_data > 0) && !i.deletable" class="muted">No actions</span>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</nz-spin>
